export default __webpack_public_path__ + "static/media/building-sauna.cead33b0.svg";